import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DaterangePickerpresent from "../../common/DateRangePickerpresent";
import { getHubName } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import toast from "react-hot-toast";
import Commongrid from "../../common/Commongrid";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";

function createData(id, licensePlate, name, city, group) {
  return {
    id,
    licensePlate,
    name,
    city,
    group,
  };
}

const Availablevehicles = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [copied, setCopied] = useState(false);
  const cities = useSelector((state) => state?.cities?.citiesData);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAgo.setHours(0, 0, 0, 0);
  let formattedDate = moment(today).format("YYYY-MM-DD");
  const currentTimeStr = today.toTimeString().slice(0, 5); // HH:mm
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [selectionRange, setSelectionRange] = useState({
    startDate: today,
    endDate: today,
    key: "selection",
  });
  const [loading, setLoading] = useState(false);
  const [city, setCity] = useState("");
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState(null);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 100,
  });
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [getUnsoldVehicles, setUnsoldVehicles] = useState([]);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const getCurrentTimeSlot = () => {
    const now = new Date();
    let hours = now.getHours();
    const mins = now.getMinutes();

    let minutes;

    if (mins <= 15) {
      minutes = "00";
    } else if (mins <= 30) {
      minutes = "30";
    } else {
      minutes = "00";
      hours = (hours + 1) % 24; // handle 24:00 edge case
    }

    return `${String(hours).padStart(2, "0")}:${minutes}`;
  };

  useEffect(() => {
    const todayDate = moment().format("YYYY-MM-DD");
    const currentTime = getCurrentTimeSlot(); // 👈 access here

    setStartDate(todayDate);
    setStartTime(currentTime);
  }, []);

  const handleCityChange = (value) => {
    setCity(value);
    getHubNames(value);
  };

  const handleHubChange = (value) => {
    setHub(value);
  };

  const getHubNames = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  useEffect(() => {
    if (city) {
      getHubName(city);
    }
  }, [city]);

  useEffect(() => {
    if (endTime) {
      handleSubmit();
    }
  }, [endTime]);

  const handleSubmit = async (
    customPage = page,
    customRowsPerPage = paginationModel.pageSize,
  ) => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    const offset = (customPage ?? 0) * (customRowsPerPage ?? rowsPerPage);
    let query = "";

    if (startDate && startTime && endDate && endTime) {
      query += `&startDate=${startDate + "T" + startTime}&endDate=${endDate + "T" + endTime}`;
    }

    if (city) {
      query += `&cityId=${city}`;
    }

    if (hub) {
      query += `&hubId=${hub}`;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/vehiclebookings/unsoldvehicles?limit=${customRowsPerPage}&offset=${offset}${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setTotalCount(data?.entities?.count || 0);
        setUnsoldVehicles(data?.dataValues?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 70,
      align: "start",
      sortable: false,
    },
    {
      field: "licensePlate",
      headerName: "Registration No",
      minWidth: 200,
      align: "start",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // 👈 center vertically
            justifyContent: "center",
            gap: 1,
            width: "100%",
          }}
        >
          <span>{params.value || "-"}</span>

          {params.value && (
            <ContentCopyIcon
              sx={{
                fontSize: 18,
                cursor: "pointer",
                color: copied === params.value ? "green" : "grey",
                transition: "color 0.2s",
              }}
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(params.value);
                setCopied(params.value);
                setTimeout(() => setCopied(false), 1500);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "name",
      headerName: "Vehicle Name",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "city",
      headerName: "City",
      minWidth: 190,
      align: "start",
    },
    {
      field: "group",
      headerName: "vehicle Group",
      minWidth: 190,
      align: "start",
    },
  ];

  const rows =
    (getUnsoldVehicles &&
      getUnsoldVehicles?.map((item) =>
        createData(
          item?.id,
          item?.licensePlate || "/",
          item?.name || "/",
          item?.cityText,
          item?.vehicleGroupText,
        ),
      )) ||
    [];

  return (
    <div>
      <h1 className="text-md md:text-xl font-semibold mt-4">View Available vehicles</h1>
      <Box className="w-full p-8 bg-white rounded-xl shadow-2xl flex justify-start gap-4 mt-4">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {/* Start Date */}
          <div className="flex flex-col gap-2">
            <label
              htmlFor="startDate"
              className="text-sm font-medium text-gray-700"
            >
              Start Date
            </label>
            <input
              id="startDate"
              type="date"
              value={startDate || formattedDate}
              min={formattedDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="h-12 px-4 border border-gray-300 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Start Time */}
          <div className="flex flex-col gap-2">
            <label
              htmlFor="startTime"
              className="text-sm font-medium text-gray-700"
            >
              Start Time
            </label>
            <select
              id="startTime"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              className="h-12 px-4 border border-gray-300 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Start Time</option>
              {Array.from({ length: 48 }, (_, i) => {
                const hours = Math.floor(i / 2);
                const minutes = i % 2 === 0 ? "00" : "30";
                const time = `${String(hours).padStart(2, "0")}:${minutes}`;
                return (
                  <option key={time} value={time}>
                    {time}
                  </option>
                );
              })}
            </select>
          </div>

          {/* End Date */}
          <div className="flex flex-col gap-2">
            <label
              htmlFor="endDate"
              className="text-sm font-medium text-gray-700"
            >
              End Date
            </label>
            <input
              id="endDate"
              type="date"
              value={endDate}
              min={startDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="h-12 px-4 border border-gray-300 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* End Time */}
          <div className="flex flex-col gap-2">
            <label
              htmlFor="endTime"
              className="text-sm font-medium text-gray-700"
            >
              End Time
            </label>
            <select
              id="endTime"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              className="h-12 px-4 border border-gray-300 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select End Time</option>
              {Array.from({ length: 48 }, (_, i) => {
                const hours = Math.floor(i / 2);
                const minutes = i % 2 === 0 ? "00" : "30";
                const time = `${String(hours).padStart(2, "0")}:${minutes}`;
                return (
                  <option key={time} value={time}>
                    {time}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <Box className="mt-5">
          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            onClick={() => {
              if (!endDate) {
                return toast.error("Select End Date", {
                  position: "top-center",
                  style: {
                    background: "white", // override background
                    color: "red",
                    fontWeight: "medium",
                    marginBottom: "20px",
                  },
                });
              } else if (!endTime) {
                return toast.error("Select End Time", {
                  position: "top-center",
                  style: {
                    background: "white", // override background
                    color: "red",
                    fontWeight: "medium",
                    marginBottom: "20px",
                  },
                });
              } else {
                handleSubmit();
              }
            }}
          >
            Submit
          </Button>
        </Box>
      </Box>

      <div className="mt-4 mx-auto">
        <Commongrid
          rows={rows}
          columns={columns}
          totalCount={totalCount}
          handleViewClick={() => {}}
          api={handleSubmit}
          setPaginationModel={setPaginationModel}
          paginationModel={paginationModel}
          loading={loading}
          disableColumnMenu={true}
        />
      </div>
    </div>
  );
};

export default Availablevehicles;
